/**
 * Erreurs liées aux liens partagés
 */

import { ERROR_CODES } from '@repo/contracts/errors';

import { ErrorConfigWithCallback } from './types';

export const SHARED_LINK_ERRORS: Record<string, ErrorConfigWithCallback> = {
    [ERROR_CODES.SHARED_LINK_FORBIDDEN]: {
        messageKey: 'shared-link-forbidden',
        severity: 'error',
    },
};
